/**
 * Shared design tokens for the hierarchical PAMM offers tree.
 *
 * The reference design is a Tailwind prototype; these constants translate its palette
 * into plain values usable by Material-UI `makeStyles` / emotion in this repo.
 */
export const COLORS = {
  brand: '#007AFF',
  success: '#1DCD9A',
  foreground: '#1F2937',
  mutedText: '#6B7280',
  border: '#E5E7EB',
  cardBg: '#FFFFFF',
  mutedBg: '#F8FAFC',
  infoBg: '#EFF6FF',
  infoBorder: '#BFDBFE',
  infoText: '#1E3A8A',
}

/** Per-depth accent colours — index 0 is the root, the last entry covers level 3 and deeper. */
export const LEVEL_COLORS = ['#007AFF', '#7C3AED', '#0EA5E9', '#F59E0B']

/** Returns the accent colour for a given tree depth, clamped to the deepest defined level. */
export const getLevelColor = (level: number): string =>
  LEVEL_COLORS[Math.min(Math.max(level, 0), LEVEL_COLORS.length - 1)]
